/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { __extends } from "tslib";
import { BaseEditorView } from "./BaseEditorView";
import { runOn, delegateCombine, delegateRemove, typeCast, markType } from "igniteui-react-core";
import { IDataSource_$type } from "igniteui-react-core";
import { stringIsNullOrWhiteSpace } from "igniteui-react-core";
/**
 * @hidden
 */
var ComboEditorView = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(ComboEditorView, _super);
    function ComboEditorView(a, b, c) {
        var _this = _super.call(this, a, c) || this;
        _this.y = null;
        _this.x = null;
        _this.aa = null;
        _this.ab = null;
        _this.ad = null;
        _this.v = null;
        _this.z = false;
        var d = a.createElement("div");
        d.setRawStyleProperty("margin-top", "-10px");
        d.setRawStyleProperty("height", "38px");
        d.setRawStyleProperty("width", "100%");
        _this.container = d;
        a.getPortal(d, "MultiColumnComboBox", function (e) {
            _this.x = e.componentRef;
            _this.aa = _this.x.i;
            _this.x.height = "100%";
            _this.x.density = 3;
            _this.x.baseTheme = b;
            _this.x.labelVisible = false;
            _this.x.columnHeadersVisible = false;
            _this.x.rowSeparatorsVisible = false;
            _this.al();
            _this.u();
            if (_this.y != null) {
                _this.x.textStyle = _this.y.fontString;
            }
            _this.attachEvents();
        }, false);
        return _this;
    }
    Object.defineProperty(ComboEditorView.prototype, "ac", {
        get: function () {
            return this.ab;
        },
        set: function (a) {
            var b = this.ab;
            this.ab = a;
            if (b != this.ab) {
                this.t("DataSource", b, this.ab);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComboEditorView.prototype, "af", {
        get: function () {
            return this.ad;
        },
        set: function (a) {
            var b = this.ad;
            this.ad = a;
            if (b != this.ad) {
                this.t("TextField", b, this.ad);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComboEditorView.prototype, "w", {
        get: function () {
            return this.v;
        },
        set: function (a) {
            var b = this.v;
            this.v = a;
            if (b != this.v) {
                this.t("ValueField", b, this.v);
            }
        },
        enumerable: false,
        configurable: true
    });
    ComboEditorView.prototype.setFont = function (a) {
        this.y = a;
        if (this.x != null && this.y != null) {
            this.x.textStyle = this.y.fontString;
        }
    };
    ComboEditorView.prototype.attachEvents = function () {
        if (this.x != null) {
            var a = this.x;
            a.valueChanged = delegateCombine(a.valueChanged, runOn(this, this.onComboValueChanged));
            var b = this.x;
            b.textChanged = delegateCombine(b.textChanged, runOn(this, this.onComboTextChanged));
            var c = this.x;
            c.gotFocus = delegateCombine(c.gotFocus, runOn(this, this.onComboGotFocus));
            var d = this.x;
            d.lostFocus = delegateCombine(d.lostFocus, runOn(this, this.onComboLostFocus));
            var e = this.x;
            e.keyDown = delegateCombine(e.keyDown, runOn(this, this.onInputKeyDown));
            var f = this.x;
            f.changing = delegateCombine(f.changing, runOn(this, this.onInputChanging));
        }
    };
    ComboEditorView.prototype.detachEvents = function () {
        if (this.x != null) {
            var a = this.x;
            a.valueChanged = delegateRemove(a.valueChanged, runOn(this, this.onComboValueChanged));
            var b = this.x;
            b.textChanged = delegateRemove(b.textChanged, runOn(this, this.onComboTextChanged));
            var c = this.x;
            c.gotFocus = delegateRemove(c.gotFocus, runOn(this, this.onComboGotFocus));
            var d = this.x;
            d.lostFocus = delegateRemove(d.lostFocus, runOn(this, this.onComboLostFocus));
            var e = this.x;
            e.keyDown = delegateRemove(e.keyDown, runOn(this, this.onInputKeyDown));
            var f = this.x;
            f.changing = delegateRemove(f.changing, runOn(this, this.onInputChanging));
        }
    };
    ComboEditorView.prototype.onTargetChanged = function () {
        if (this.x != null) {
            this.z = true;
            if (this.x.value == null && this.x.text != "") {
                this.x.text = "";
            }
            this.focus();
            this.z = false;
        }
    };
    ComboEditorView.prototype.onEditStarted = function () {
        _super.prototype.onEditStarted.call(this);
        var a = this.container.getNativeElement();
        this.x.defaultColumnWidth = (a.clientWidth - 2).toString();
        if (!this.a.isEditRefocusDesired) {
            this.focus();
        }
    };
    ComboEditorView.prototype.onEditEnded = function () {
        _super.prototype.onEditEnded.call(this);
        if (this.a.isEditRefocusDesired) {
            var a = this.h.rootWrapper.getNativeElement();
            if (a == document.activeElement || a.contains(document.activeElement)) {
                this.focus();
            }
        }
    };
    ComboEditorView.prototype.r = function () {
        if (this.x != null) {
            this.aa.focus(true);
            this.x.select();
        }
    };
    ComboEditorView.prototype.ai = function () {
        if (this.x != null) {
            this.x.closeUp();
        }
    };
    ComboEditorView.prototype.t = function (a, b, c) {
        _super.prototype.t.call(this, a, b, c);
        switch (a) {
            case "DataSource":
            case "TextField":
            case "ValueField":
                this.al();
                break;
        }
    };
    ComboEditorView.prototype.u = function () {
        this.z = true;
        if (this.x != null) {
            if (this.value == null) {
                this.x.text = " ";
            }
            this.x.value = this.value;
            this.r();
        }
        this.z = false;
    };
    ComboEditorView.prototype.al = function () {
        if (this.x != null) {
            this.detachEvents();
            this.x.dataSource = this.ac;
            this.x.textField = this.af;
            this.x.valueField = this.w;
            if (this.af != null) {
                this.x.fields = [this.af];
            }
            else if (this.w != null && this.w.length > 0) {
                this.x.fields = [this.w[0]];
            }
            else {
                var a = typeCast(IDataSource_$type, this.ac);
                if (a != null && a.actualSchema != null) {
                    this.x.fields = [a.actualSchema.propertyNames[0]];
                }
                else {
                    var b = (Array.isArray(this.ac));
                    if (b) {
                        var c = (Object.keys(this.ac[0]));
                        if (c.length > 0) {
                            this.x.fields = [c[0]];
                        }
                    }
                }
            }
            this.attachEvents();
        }
    };
    ComboEditorView.prototype.onComboValueChanged = function (a, b) {
        this.ap();
    };
    ComboEditorView.prototype.onComboTextChanged = function (a, b) {
        this.ap();
    };
    ComboEditorView.prototype.ap = function () {
        if (this.z) {
            return;
        }
        if (this.x.value != null) {
            this.p(this.x.value, false);
        }
        else if (this.x.value == null && stringIsNullOrWhiteSpace(this.x.text)) {
            this.p(null, false);
        }
        else {
            this.p(this.value, false);
        }
    };
    ComboEditorView.prototype.onInputChanging = function (a, b) {
        this.o();
    };
    ComboEditorView.prototype.onComboLostFocus = function (a) {
        this.n();
    };
    ComboEditorView.prototype.onComboGotFocus = function (a) {
        this.m();
    };
    ComboEditorView.$t = markType(ComboEditorView, 'ComboEditorView', BaseEditorView.$);
    return ComboEditorView;
}(BaseEditorView));
export { ComboEditorView };
//# sourceMappingURL=ComboEditorView.js.map
